export class Customer {
    public customerId: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public email2: string;
    public mobilePhoneNumber: string;
    public status: CustomerStatus;
    public token: string;
    public tokenExpiry: Date;
    public skinTypeId: number;
    public dateOfBirth: string;
    public address: any;
    public sendSms: boolean;
    public sendEmail: boolean;
    public sendPhone: boolean;
    public gender: Gender;
    public isNewCustomer: boolean;
    public healthFundId: string;
    public lastTransactionDate: string;
    public dateJoined: string;
    public is2YearLastTransaction: boolean;
    public hasPaidAppointment: boolean;
}

export enum CustomerStatus {
    EmailVerified = 1,
    WaitingForEmailVerification = 2,
    ForCustomerMigration = 3,
    Blocked = 4,
    RequiredForUpdateEmailVerification = 5
}

export enum ProcessStatus {
    SelectTreatment = 0,
    SelectedTreatment = 1,
    SelectedDateAndTime = 2,    
    ConfirmAppointment = 3,
    SelectGiftVoucher = 5,
    Checkout = 6,
    Result = 4
}

export class LoginBindingModel {
    public email: string;
    public password: string;
}

export class LogoutViewModel {
    public logout: boolean;
}

export class CheckEmailStatusBindingModel {
    public email: string;
}

export class CheckEmailStatusViewModel {
    public status: EmailStatus;
}

export enum EmailStatus {
    NotYetRegistered = 0,
    EmailVerified = 1,
    WaitingForEmailVerification = 2,
    ForCustomerMigration = 3,
    Blocked = 4
}

export class SendMigrationLinkBindingModel {
    public email: string;
    public branchId: string;
}

export class SendMigrationLinkViewModel {
    public sent: boolean;
    public customerId: string;
}

export class SendEmailValidationLinkBindingModel {
    public email: string;
    public branchId: string;
}

export class SendEmailVerificationViewModel {
    public sent: boolean;
    public customerId: string;
}

export class SendEmailVerificationBindingModel {
    public email: string;
}

export class SendPasswordResetKeyLinkToEmailBindingModel {
    public email: string;
}

export class SendPasswordResetKeyLinkToEmailViewModel {
    public sent: boolean;
    public customerId: string;
}

export class IsValidPasswordResetKeyBindingModel {
    public resetKey: string;
    public customerId: string;
}

export class IsValidPasswordResetKeyViewModel {
    public valid: boolean;
    public email: string;
}

export class ResetPasswordBindingModel {
    public customerId: string;
    public resetKey: string;
    public newPassword: string;
    public confirmNewPassword: string;
}

export class ResetPasswordViewModel {
    public reset: boolean;
}

export class RegisterCustomerBindingModel {
    public email: string;
    public password: string;
    public confirmPassword: string;
    public firstName: string;
    public lastName: string;
    public mobilePhoneNumber: string;
    public postcode: string;
    public branchId: string;
    public healthFundId: string;
    public dateOfBirths: Date;
    public dateOfBirth: string;
    public gender: Gender;
    public countryId: string;
    public stateId: string;
    public address1: string;
    public address3: string;
    public sendSms: boolean;
    public sendEmail: boolean;
    public sendPhone: boolean;
}

export enum Gender {
    None = 0,
    Male = 1,
    Female = 2
}

export class UpdateDetailsBindingModel {
    public firstName: string;
    public lastName: string;
    public mobilePhoneNumber: string;
    public postcode: string;
    public dateOfBirth: Date;
    public gender: Gender;
}

export class UpdateDetailsViewModel {
    public updated: boolean;
}

export class ChangePasswordBindingModel {
    public oldPassword: string;
    public newPassword: string;
    public confirmPassword: string;
}

export class SetPasswordViewModel {
    public updated: boolean;
}

export class CustomerTransactionBindingModel {
    public branchId: number;
}

export class GetLoyaltyPointsBindingModel {
    public branchId: number;
}
export class GetLoyaltyPointsViewModel {
    public registeredDate: Date;
    public tierId: number;
    public tierName: string;
    public tierCode: string
    public bluePoints: number;
    public sequence: number;
}
export class CustomerTransaction {
    public pointsAwardHistories: AwardHistory[];
    public unUsedPackages: UnUsedPackage[];
    public incomingAppointments: IncomingAppointments[];
}


export class AwardHistory {
    public awardDate: Date;
    public tenderedAmount: number;
    public pointsAwarded: number;
    public purchasedItems: PurchasedItem[]
}

export class PurchasedItem {
    public description: string;
    public unitPrice: number;
    public quantity: number;
    public totalTax: number;
    public totalPrice: number;
}

export class IncomingAppointments {
    public appointmentDate: Date;
    public description: string;
    public duration: number;
}

export class UnUsedPackage {
    public unUsedPackageId: number;
    public packageId: number;
    public name: string;
    public sku: string;
    public description: string;
    public imageUrl: string;
    public quantity: number;
    public quantityUsed: number;
    public quantityLeft: number;
    public packageTreatments: PackageTreatment[];
}

export class PackageTreatment {
    public packageTreatmentId: number;
    public name: string;
    public sku: string;
    public description: string;
    public imageUrl: string;
    public consultationRequired: boolean;
    public hasIncomingConsultation: boolean;
}

export class MigrateCustomerBindingModel {
    public password: string;
    public confirmPassword: string;
    public firstName: string;
    public lastName: string;
    public postcode: string;
    public address1: string;
    public address3: string;
    public mobilePhoneNumber: string;
    public migrationKey: string;
    public customerId: string;
    public dateOfBirth: string;
    public sendSms: boolean;
    public sendEmail: boolean;
    public sendPhone: boolean;
}

export class UpdateCustomerBindingModel {
    public firstName: string;
    public lastName: string;
    public postcode: string;
    public address1: string;
    public address3: string;
    public mobilePhoneNumber: string;
    public dateOfBirth: string;
    public customerId: string;
    public email: string;
    public sendSms: boolean;
    public sendEmail: boolean;
    public sendPhone: boolean;
}

export class IsValidMigrationKeyBindingModel {
    public migrationKey: string;
    public customerId: string;
}

export class IsValidMigrationKeyViewModel {
    public email: string;
    public valid: boolean;
    public firstName: string;
    public lastName: string;
    public mobilePhoneNumber: string;
    public dateOfBirth: string;
    public address: any;
    public sendSms: boolean;
    public sendEmail: boolean;
    public sendPhone: boolean;
    public gender: Gender;
    public isNewCustomer: boolean;
    public healthFundId: string;
}

export class MigrateCustomerViewModel {
    public migrated: boolean;
}

export class UpdateCustomerViewModel {
    public updated: boolean;
    public requiredForUpdateEmailVerification: boolean;
}

export class IsValidEmailVerificationKeyBindingModel {
    public emailVerificationKey: string;
    public customerId: string;
}

export class IsValidEmailVerificationkeyViewModel {
    public isValid: boolean;
}

export class VerifyCustomerEmailBindingModel {
    public emailVerificationKey: string;
}

export class VerifyCustomerEmailViewModel {
    public verified: boolean;
}

export class SetSkinTypeBindingModel {
    public skinType: number;
}

export class SetSkinTypeViewModel {
    public updated: boolean;
    public skinTypeId: number;
}

export class Branch {
    public branchId: string;
    public branchName: string;
    public contactNumber: string;
    public email: string;
    public address: string;
    public fax: string;
    public mapUrl: string;
}

export class ItemCode {
    constructor() {
        this.selected = false;
    }
    public treatmentId: string;
    public name: string;
    public description: string;
    public itemCodeType: ItemCodeType;
    public fee: number;
    public duration: number;
    public groupName: string;
    public category: string;
    public selected: boolean;
    public displayDuration: string;
    public isPromo: boolean;
    public bookingCount: number;
    public specialityId: number;
    public unlimited: boolean;
    public shortName: string;
    public packageItems: any[];
    public info: string;
    public newClientTreatment: any;
    public depositPercentage: number;
}

export class GetOpeningHoursBindingModel {
    public branchId: number;
    public preferredDate: string;
}

export class OpeningHour {
    public startTime: string;
    public endTime: string;
    public timeInterval: number;
}

export class GetConsultationGroupBindingModel {
    public branchId: number;
}

export class Consultation {
    public consultationId: number;
    public name: string;
    public sku: string;
    public description: string;
    public fee: number;
    public imageUrl: string;
    public hasIncomingBooking: boolean;
}

export class GetConsultationByPackageTreatmentIdBindingModel {
    public packageTreatmentId: number;
}

export class BookTreatmentBindingModel {
    public branchId: string;
    public packageTreatmentId: number;
    public preferredDateAndTime: string;
    public unUsedPackageId: number;
}

export class Appointment {
    public appointmentId: any;
    public appointmentDate: string;
    public isPreferredDateAndTimeAvailable: boolean;
    public processDate: string;
    public startTime: string;
    public endTime: string;
    public duration: number;
}

export class ConfirmAppointmentBindingModel {
    public appointmentId: number;
    public unUsedPackageId: number;
}

export class ConfirmAppointmentViewModel {
    public confirmed: boolean;
}

export class CancelAppointmentBindingModel {
    public appointmentId: number;
}

export class CancelAppointmentViewModel {
    public cancelled: boolean;
}


export class State {
    public stateId: string;
    public name: string;
}

export class Country {
    public countryId: string;
    public name: string;
}


export class PlaceOrderViewModel {
    public pendingTransactionId: string;
    public customerId: string;
    public giftVoucherRedeemedAmount: number;
    public onlinePaymentAmountToBePaid: number;
    public totalDiscount: number;
    public surcharged: number;
    public yieldCharged: number;
    public subTotal: number;
    public deliveryCharge: number;
    public pendingTransactionNo: string;
    public sagePayFormRequest: SagePayFormRequest;
    public onlineOrderId: string;
}

export class ComputeOrderViewModel {
    public pendingTransactionId: string;
    public customerId: string;
    public giftVoucherRedeemedAmount: number;
    public onlinePaymentAmountToBePaid: number;
    public totalDiscount: number;
    public surcharged: number;
    public yieldCharged: number;
    public subTotal: number;
    public deliveryCharge: number;
    public pendingTransactionNo: string;
    public sagePayFormRequest: SagePayFormRequest;
}

export class SagePayFormRequest {
    public formPaymentUrl: string;
    public vpsProtocol: string;
    public txType: string;
    public vendor: string;
    public crypt: string;
}

export class CancelPendingTransactionBindingModel {
    public pendingTransactionId: string;
    public customerId: string;
}

export class PlaceOrderBindingModel {
    public branchId: string;
    public customerId: string;
    public items: Item[];
    public payments: Payment[];
    public sagePayResponseHandlerPage: string;
    public enableDepositRequired: any;
}

export class Payment {
    public paymentTypeGroupId: PaymentTypeGroup;
    public giftVoucherNumber: string;
    public paymentTypeId: string;
    public amountPaid: number;
}

export class ComputeOrderBindingModel {
    public branchId: string;
    public customerId: string;
    public items: Item[];
    public payments: Payment[];
    public sagePayResponseHandlerPage: string;
    public enableDepositRequired: any;
}

export enum PaymentTypeGroup {
    Cash = 2,
    CreditCard = 3,
    Cheque = 4,
    GiftVoucher = 5,
    CreditUsed = 6,
    PmPosting = 7,
    ArPosting = 8,
    BillToAccount = 9,
    CreditRefund = 11,
    DirectDebit = 12,
    RoomCharge = 13,
    Hicaps = 14,
    MarketSmartRewards = 15,
    Web = 16,
    Others = 30,
}

export class SetTransactionAsPaidOnlineBindingModel {
    public pendingTransactionId: string;
    public customerId: string;
    public onlinePaymentTransactionId: string;
}


export class VerifyPendingTransactionBindingModel {
    public pendingTransactionId: string;
    public customerId: string;
}

export class CommitPaymentBindingModel {
    public pendingTransactionId: string;
    public customerId: string;
    public onlinePaymentTransactionId: string;
}

export class CommitPaymentViewModel {
    public pendingTransactionId: string;
    public customerId: string;
    public receiptUrl: string;
    public giftVoucherUrl: string;
    public receiptNumber: string;
    public bookingReference: string;
    public amount: number;
    public totalDiscount: number;
    public printOnCheckout: boolean;
}

export class SendTransactionToEmailBindingModel {
    public pendingTransactionId: string;
    public customerId: string;
    public token: string;
}


export enum PendingTrasactionStatus {
    Pending = 1,
    Successful = 2,
    Cancelled = 3,
    Deleted = 4,
    Failed = 5,
    OnlinePaymentSuccessful = 6,
    ConvertingToInvoice = 7,
    TransactionTimeOut = 8,
    TransactionTimeOutButPaid = 9
}

export class Item {

    public giftVoucherReceiverCollectorName: string
    public giftVoucherFrom: string
    public giftVoucherMessage: string
    public giftVoucherReceiverCollectorId: string
    public giftVoucherReceiverCollectorEmail: string
    public giftVoucherReceiverCollectorMobileNumber: string
    public giftVoucherCollectionDate: string
    public giftVoucherReceiverCollectorAddress1: string
    public giftVoucherReceiverCollectorAddress2: string
    public giftVoucherReceiverCollectorCity: string
    public giftVoucherReceiverCollectorState: string
    public giftVoucherReceiverCollectorPostCode: string
    public giftVoucherTemplateFileName: string
    public itemId: string;
    public description: string;
    public quantity: number;
    public fee: number;
    public amount: number;
    public discount: number;
    public tax: number;
    public giftVoucherOptionType: GiftVoucherOptionType;
    public invoiceDetailType: InvoiceDetailType;
    public staffId: string;
    public appointmentId: string;
    public bookingReference: string;
    public roomId: string;
    public staffName: string;
    public bookingDate: string;
    public customerId: string;
    public startTime: string;
    public endTime: string;

    
    public originalFee: number;
    public depositAmount: number;
    public depositPercentage: number;

    public giftVoucherId: string;
    public name: string;
    public groupName: string;
    public selected: boolean;
    public imageUrl: string;
    public isForMySelf: boolean;
    public beneficiary: Beneficiary;

}


export enum InvoiceDetailType {
    SurChargeItem = -3,
    SpecialBooking = -2,
    DefaultDeliveryItem = -1,
    Service = 1,
    Class = 2,
    Membership = 3,
    GiftVoucher = 4,
    FoodAndBeverage = 6,
    Package = 9,
    DestinationPackage = 10,
    DirectDebit = 11,
    FacilityService = 12,
    Series = 13,
    Stock = 20,
    Credit = 21,
    Tip = 22,
    Refund = 25,
    StockDelivery = 26,
    None = 0
}

export enum GiftVoucherOptionType {
    NotGiftVoucher = 0,
    IsElectronic = 1,
    IsGiftBoxed = 2,
    IsRegularPost = 3,
    IsExpressPost = 4,
    IsPrintAtHome = 5,
    IsPickUp = 6,
    IsPickUpBranch1 = 7,
    IsPickUpBranch2 = 8,
    IsPickUpBranch3 = 9,
    IsPickUpBranch4 = 10,
}

export class ValidateGiftVoucherByNumberBindingModel {
    public giftVoucherNumber: string;
}

export class ValidateGiftVouchersViewModel {
    public totalRemainingAmount: number;
}

export enum ItemCodeType {
    Service = 1,
    Package = 9
}

export class AppointmentDate {
    appointmentDate: string;
    unitPrice: number;
    yielfPrice: number;
    availableHours: AvailableHour[];
    availableTimes: AvailableTime[];
    timeGroupings: TimeGrouping[];
}

export class AvailableHour {
    slotCount: number;
    availableTimes: AvailableTime[];
    time: string;
}

export class TimeGrouping {
    slotCount: number;
    availableTimes: AvailableTime[];
    name: string;
    hourEnd: string;
    hourStart: string;
}

export class AvailableTime {
    slotCount: number;
    slots: Slot[];
    time: string;
}

export class Slot {
    endTime: string;
    equipmentId: string;
    roomId: string;
    staffId: string;
    staffName: string;
    slotCount: number;
    time: string;
}



export class DownloadGiftVoucherBindingModel {

    public pendingTransactionId: string;
    public customerId: string;
    public token: string;

}

export class DownloadGiftVoucherViewModel {

    public url: string;

}


export class GiftVoucher {

    constructor() {
        this.selected = false;
    }
    public giftVoucherId: string;
    public name: string;
    public description: string;
    public fee: number;
    public groupName: string;
    public selected: boolean;
    public imageUrl: string;
    public isForMySelf: boolean;
    public beneficiary: Beneficiary;

}

export class Beneficiary {

    public customerId: string;
    public firstName: string;
    public lastName: string;
    public message: string;

}

